import { Component, OnInit, OnDestroy } from '@angular/core';
import { Router } from '@angular/router';
import { MatDialog } from '@angular/material';
import { Store } from '@ngrx/store';

import { LoginModel, LoginFormModel, LoginStoreModel } from './login.model';
import LoginForm from './login.form';
import { ErrorComponent } from '../popups/error/error.component';

import { State } from '../../reducers/index';
import { HIDE_HEADER, OVERLAY_START } from '../../actions/header.action';
import { Booking } from '../../actions/booking.action';
import { Login, LOGIN_REQUEST } from '../../actions/login.action';

@Component({
  selector: 'consentz-login-component',
  templateUrl: './login.template.html',
  styleUrls: ['./login.styles.scss']
})
export class LoginComponent implements OnInit, OnDestroy {
  public model: LoginModel = new LoginModel(
    JSON.parse(localStorage.getItem('currentBookingOptions')),
    localStorage.getItem('AppId') ? localStorage.getItem('AppId') : window.location.hash.split('/')[1]
  );
  public subscription: LoginStoreModel = new LoginStoreModel();
  private form: LoginForm;

  constructor(
    private router: Router,
    private dialog: MatDialog,
    private store: Store<State>
  ) {
    // create reactive form, hide header, subscribtion on widget options
    this.form = new LoginForm(new LoginFormModel());
    this.store.dispatch({ type: HIDE_HEADER });
    this.subscription.booking$ = store.select<any>('booking').subscribe((data: Booking) => {
      if (Object.keys(data).find(key => key === 'primaryFontColour')) {
        this.model.currentBookingOptions = data;
      }
    });
  }

  // open angular material dialog
  public openDialog(message: any): void {
    const dialogRef = this.dialog.open(ErrorComponent, {
      width: '90%',
      data: message,
    });
  }
  // subscribe on login response and check error
  public ngOnInit(): void {
    if (localStorage.getItem('currentUser') || localStorage.getItem('currentUserToken')) {
      window.history.back();
    }
    this.subscription.login$ = this.store.select<any>('login').subscribe((data: Login) => {
      if (data['error']) {
        this.openDialog({
          status: 'Error',
          message: data['error'].error ? data['error'].error.error.message : 'You enter invalid data. Please, check it and try again.',
          type: 'login'
        });
      }
    });
  }
  // unsubscribe from store
  public ngOnDestroy(): void {
    this.subscription.login$.unsubscribe();
    this.subscription.booking$.unsubscribe();
  }
  // login request with starting overlay
  private submit(): void {
    this.store.dispatch({ type: OVERLAY_START });
    this.store.dispatch({
      type: LOGIN_REQUEST,
      payload: {
        username: this.form.model.username,
        password: this.form.model.password
      }
    });
  }
}



// WEBPACK FOOTER //
// /Users/dtrubetskoi/Desktop/projects/online-booking-widget/src/app/components/login/login.component.ts